<template>
    <span @click.prevent="showDialog">
      <FormOutlined v-if="!hideIcon"></FormOutlined>
      <span :class="hideIcon?'':'ml10'">
        <slot>意见反馈</slot>
      </span>
    </span>
  <a-modal
    title="反馈意见和建议"
    v-model:visible="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
  >
    <a-form layout="vertical" ref="formRef" :model="formState" :rules="rules">
      <a-form-item label="您的称呼：">
        <a-input
          placeholder="称呼，40字符以内，选填"
          :maxlength="50"
          v-model:value="formState.name"
        >
          <template #suffix>
            <span class="text-grey"> {{ formState.name.length }}/50 </span>
          </template>
        </a-input>
      </a-form-item>
      <a-form-item label="联系电话：">
        <a-input
          placeholder="建议留手机号，方便联系您"
          :maxlength="20"
          v-model:value="formState.mobile"
        >
          <template #suffix>
            <span class="text-grey"> {{ formState.mobile.length }}/20 </span>
          </template>
        </a-input>
      </a-form-item>
      <a-form-item label="反馈意见：" name="content">
        <a-textarea
          v-model:value="formState.content"
          :maxlength="1000"
          placeholder="请输入您的反馈意见或建议，1000字以内，必填"
          :auto-size="{ minRows: 3 }"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, reactive, ref, toRefs } from "vue";
import { FormOutlined } from "@ant-design/icons-vue";
import { FeedbackReq } from "@/views/join/join.interface";
import { JoinService } from "@/views/join/join.service";
import { message } from "ant-design-vue";

export default defineComponent({
  name: "TheFeedback",
  components: {
    FormOutlined,
  },
  props:{
    hideIcon:{
      type:Boolean,
      default:false
    }
  },
  setup() {
    const state = reactive({
      formRef: ref(),
      visible: false,
      confirmLoading: false,
      formState: new FeedbackReq(),
      rules: {
        content: [{ required: true, message: "请输入反馈意见", trigger: "blur" }],
      },
    });
    const showDialog = () => {
      state.formState = new FeedbackReq();
      state.visible = true;
    };
    const handleOk = async () => {
      await state.formRef.validate();
      try {
        state.confirmLoading = true;
        const { run } = JoinService.useFeedbackApi();
        let res = await run(state.formState);
        if (res.respCode === "0000") {
          message.success("反馈成功");
          state.visible = false;
        } else {
          message.error(res.respDesc);
        }
      } finally {
        state.confirmLoading = false;
      }
    };
    return {
      ...toRefs(state),
      showDialog,
      handleOk,
    };
  },
});
</script>

<style scoped></style>
